import { render, staticRenderFns } from "./CurrentOrdersTableAdmin.vue?vue&type=template&id=1471cf62&scoped=true"
import script from "./CurrentOrdersTableAdmin.vue?vue&type=script&lang=js"
export * from "./CurrentOrdersTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471cf62",
  null
  
)

export default component.exports